module.exports = __webpack_public_path__ + "img/twitch.aa7d68ef.png";